<template>
  <div>
    <div class='top' style='width: 100%; font-weight: bold;'>
      <div style='display: inline-block;margin-left: 10px;'>
        <img src="~@/assets/FJLogo.png" alt="logo">
      </div>
      <div style='float: right;margin-right: 20px;font-size: 12px;'>
        <span style='margin-left: 60px'><a href='https://fzztb.fzsggzyjyfwzx.cn/portal/news?classifyCode=A01A08'
                                           target='_blank'><img src='~@/assets/province/login/help.png'
                                                                style='margin-right: 4px'>帮助中心</a></span>
        <div style='margin-left: 60px;cursor: pointer;display: inline-block;position: relative'
             @mouseenter='serviceMouseenter'><img src='~@/assets/province/login/service.png' style='margin-right: 4px'>
          在线客服
          <div v-show='serviceMouseOn' @mouseleave='serviceMouseleave' style='position: absolute;width: 150%'>
            <div
              style='cursor: pointer;text-decoration:underline; text-align: left; margin-top: 10px;'
              @click="openQQ('1')">
              <img src='~@/assets/sendqq.png' width='15' height='15'>
              招标代理
            </div>
            <div
              style='cursor: pointer;text-decoration:underline; text-align: left; margin-top: 5px;'
              @click="openQQ('2')">
              <img src='~@/assets/sendqq.png' width='15' height='15'>
              投标企业1群
            </div>
            <div
              style='cursor: pointer;text-decoration:underline; text-align: left; margin-top: 5px;'
              @click="openQQ('3')">
              <img src='~@/assets/sendqq.png' width='15' height='15'>
              投标企业2群
            </div>
            <div
              style='cursor: pointer;text-decoration:underline; text-align: left; margin-top: 5px;'
              @click="openQQ('4')">
              <img src='~@/assets/sendqq.png' width='15' height='15'>
              投标企业3群
            </div>
          </div>
        </div>

        <!--        <span style='margin-left: 60px'><img src='~@/assets/province/login/complaint.png' style='margin-right: 4px'>在线投诉</span>-->
        <span style='margin-left: 60px'><img src='~@/assets/province/login/phone.png' style='margin-right: 4px'>客服热线 0591-87585006</span>
      </div>
    </div>

    <div class='bg' style=' width: 100%;'>
      <div style='margin: 0;height: 0'>&nbsp;</div>
      <div
        style='font-size: 40px;font-weight:500;color: #192A44;margin-top: 40px;margin-bottom: 40px;width: 100%; text-align: center'>
        福州市电子招投标交易系统
      </div>
      <div
        style='width: 400px;height: 520px;background:linear-gradient(rgba(252, 253, 255, 1), rgba(252, 253, 255, 0.7));margin: 0 auto;border-radius: 8px;position: relative'>
        <a-form :form='form' class='user-layout-login' ref='formLogin' id='formLogin'>
          <!--          <div class='qrcode' style='position: absolute;right: 0;width: 50px;height: 50px'>&nbsp;</div>
                    <div
                      style='background: linear-gradient(224deg, transparent 35px, rgb(252 253 255) 0px);position: absolute;right: 0;width: 50px;height: 50px'>
                      &nbsp;
                    </div>-->
          <div
            style='height:60px;line-height: 60px;font-size: 22px;width: 300px;margin: 0 auto; text-align: center;font-weight:500;color: #0059b4;border-bottom: 2px solid #f0f1f5;'>
            <span>欢迎登录</span>
          </div>
          <div style='width: 360px;margin: 0 auto;display: flex;justify-content:space-around;'>
            <div
              style='display: flex;height:60px;text-align: center;font-size: 14px;font-weight:500;align-items: center;justify-content: center;'>
              <span style='color: #0059b4;border-bottom: 2px solid #0059b4'>账号登录</span>
            </div>
            <div
              style='display: flex;height:60px;text-align: center;font-size: 14px;font-weight:500;align-items: center;justify-content: center;'>
              <!--              <div>短信登录</div>-->
            </div>
            <div
              style='display: flex;height:60px;text-align: center;font-size: 14px;font-weight:500;align-items: center;justify-content: center;'>
              <!--              <div>CA登录</div>-->
            </div>
          </div>
          <div style='width: 300px;margin: 0 auto;'>
            账号
          </div>
          <div style='width: 300px;margin: 0 auto;'>
            <a-form-item>
              <a-input
                v-decorator="['username',validatorRules.username,{ validator: this.handleUsernameOrEmail }]"
                type='text'
                placeholder='请输入账号'>
                <template #prefix>
                  <img src='~@/assets/province/login/account.png'>
                </template>
              </a-input>
            </a-form-item>
          </div>
          <div style='width: 300px;margin: 0 auto;'>
            密码
          </div>
          <div style='width: 300px;margin: 0 auto;'>
            <a-form-item>
              <a-input
                v-decorator="['password',validatorRules.password]"
                type='password'
                autocomplete='false'
                placeholder='请输入密码'>
                <template #prefix>
                  <img src='~@/assets/province/login/password.png'>
                </template>
              </a-input>
            </a-form-item>
          </div>
          <div style='width: 300px;margin: 0 auto;'>
            验证码
          </div>
          <div style='width: 300px;margin: 0 auto;'>
            <a-form-item>
              <a-input
                v-decorator="['inputCode',validatorRules.inputCode]"
                type='text'
                @change='inputCodeChange'
                placeholder='请输入验证码'>
                <template #prefix>
                  <img src='~@/assets/province/login/vcode.png'>
                </template>
                <template #suffix>
                  <div style='position: absolute;right: -11px;'>
                    <img v-if='requestCodeSuccess' style='height: 30px' :src='randCodeImage'
                         @click='handleChangeCheckCode' />
                    <img v-else style='height: 30px' src='../../assets/checkcode.png' @click='handleChangeCheckCode' />
                  </div>
                </template>
              </a-input>
            </a-form-item>
          </div>
          <div style='width: 300px;margin: 20px auto;display: flex;justify-content: space-between;'>
            <span>首次登录平台请<router-link :to="{ name: 'register'}">点击注册</router-link></span>
            <span><a href='https://fzztb.fzsggzyjyfwzx.cn/portal/newsInfo?id=1723947120983515137'
                     target='_blank'>忘记密码</a></span>
          </div>

          <div class='login-button un-select'
               type='button'
               style='width: 300px;margin: 20px auto;height: 49px;line-height: 49px;text-align: center;font-size: 16px;font-weight:400;color: #FFF;cursor: pointer;'
               :loading='loginBtn'
               @click='handleSubmit'
               :disabled='loginBtn'
          >
            立即登录
          </div>

          <div
            style='width: 300px;margin: 10px auto;text-align: center;font-size: 14px;display: flex;align-items: center;'>
            <div class='line'></div>
            <span class='text'>其他登录方式</span>
            <div class='line'></div>
          </div>

          <div
            style='width: 300px;margin: 10px auto;text-align: center;font-size: 12px;display: flex;align-items: center;justify-content: space-between;'>
            <div style='display: inline-block;flex: 1'><a href='javacript:void(0);' @click='uniteLoginClick'><img
              src='~@/assets/province/login/platform.png'
              style='margin: 0 5px' alt=''><span>省平台登录</span></a>
            </div>
<!--            <div style='display: inline-block;flex: 1'><a><img src='~@/assets/province/login/login.png'
                                                               style='margin: 0 5px' alt=''><span>其他登录</span></a>
            </div>-->
          </div>
        </a-form>
      </div>
    </div>
    <login-select-tenant ref='loginSelect' @success='loginSelectOk' v-show='false'></login-select-tenant>
  </div>
</template>

<script>
import { getAction, postAction } from '@api/manage'
import JSEncrypt from 'jsencrypt'
import { mapActions } from 'vuex'
import LoginSelectTenant from '@views/user/LoginSelectTenant.vue'
import { timeFix } from '@/utils/util'
import _ from 'lodash'

export default {
  components: { LoginSelectTenant },
  data() {
    return {
      form: this.$form.createForm(this),
      loginBtn: false,
      validatorRules: {
        username: { rules: [{ required: true, message: '请输入账号!' }, { validator: this.handleUsernameOrEmail }] },
        password: { rules: [{ required: true, message: '请输入密码!', validator: 'click' }] },
        mobile: { rules: [{ validator: this.validateMobile }] },
        captcha: { rule: [{ required: true, message: '请输入验证码!' }] },
        inputCode: { rules: [{ required: true, message: '请输入验证码!' }] },
        name: { rules: [{ required: true, message: '请输入姓名!' }] },
        idCard: { rules: [{ required: true, validator: this.checkIDCard }] }
      },
      requestCodeSuccess: false,
      randCodeImage: '',
      serviceMouseOn: false,
      uniteLoginUrl: ''
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleGlobalKey)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleGlobalKey)
  },
  created() {
    this.handleChangeCheckCode()
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    serviceMouseenter() {
      this.serviceMouseOn = true
    },
    serviceMouseleave() {
      this.serviceMouseOn = false
    },
    openQQ(type) {
      let url = ''
      if (type === '1') {
        window.open('http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=PpaUaolU_RCVZQOgmR8_Ogv6TRWtF-V7&authKey=kEL0%2B1rbAucqoPOKKJWmBbG9sk9p4RU%2BXPaUF3nFYedgee2fM2wsU26YsLw42QLQ&noverify=0&group_code=105393327')
      } else if (type === '2') {
        window.open('http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=u7elDLas21Qzd-Ff2j11zs3NVia6EQDQ&authKey=4nA6fhJxial6RGX%2F85%2B46EYrs%2B95SFIMhc1%2FTC3ixK2UY%2F0om539y%2B%2FLp3JA49FR&noverify=0&group_code=540062653')
      } else if (type === '3') {
        window.open('http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=xuk1dsmeXLJfkShiCTXSYnmW7z8ElJN9&authKey=PS09yk6UEJfkfdVb3YuI0FB3788qpYfbDprYTs6dserRDp1njYDC6SbBroVnc4%2Bb&noverify=0&group_code=632853381')
      } else if (type === '4') {
        window.open('http://qm.qq.com/cgi-bin/qm/qr?_wv=1027&k=_Yjr94CXmMGlUk49AhHypnwA-11fNrbX&authKey=gxEmtp%2FNaV33upJDb3sSI5ynK1coA9vgZM21Kdl0tKXvSkh4w5hWCXnaFgoEXS6A&noverify=0&group_code=580013049')
      }
    },
    handleUsernameOrEmail(rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    handleChangeCheckCode() {
      this.currdatetime = new Date().getTime()
      getAction(`/sys/randomImage/${this.currdatetime}`).then(res => {
        if (res.success) {
          this.randCodeImage = res.result
          this.requestCodeSuccess = true
        } else {
          this.$message.error(res.message)
          this.requestCodeSuccess = false
        }
      }).catch(() => {
        this.requestCodeSuccess = false
      })
      // 登录失败、异常、重新获取验证码时，将验证码输入框置为空
      this.form.setFieldsValue({
        'inputCode': ''
      })
    },
    debouncedHandleSubmit: _.debounce(function() {
      this.handleSubmit()
    }, 500),
    handleGlobalKey(e) {
      switch(e.key) {
        case 'Enter':
          this.debouncedHandleSubmit()
          break
        case ' ':
          if (!e.repeat) this.pause() // 防止长按重复触发
          break
      }
    },
    inputCodeChange(e) {
      this.inputCodeContent = e.target.value
    },
    requestFailed(err) {
      this.handleChangeCheckCode()
      this.$notification['error']({
        message: '登录失败',
        description: ((err.response || {}).data || {}).message || err.message || '请求出现错误，请稍后再试',
        duration: 4
      })
      this.loginBtn = false
    },
    loginSelectOk() {
      this.loginSuccess()
    },
    handleSubmit() {
      let that = this
      let loginParams = {}
      that.loginBtn = true
      // 使用账户密码登录
      that.form.validateFields(['username', 'password', 'inputCode', 'rememberMe'], { force: true }, (err, values) => {
        if (!err) {

          postAction('/sys/loadRsa').then(res => {
            if (res.success) {
              loginParams.username = values.username
              loginParams.remember_me = false
              loginParams.captcha = that.inputCodeContent
              loginParams.checkKey = that.currdatetime
              loginParams.publicKey = res.result

              //私钥
              let publicKey = res.result
              let encryptor = new JSEncrypt()
              encryptor.setPublicKey(publicKey)
              let encrypedPwd = encryptor.encrypt(values.password)
              loginParams.password = encrypedPwd

              that.Login(loginParams).then((res) => {
                that.enterpriseInfo = res.result.enterpriseInfo
                that.userInfoAll = res.result
                this.$refs.loginSelect.show(res.result)
              }).catch((err) => {
                that.requestFailed(err)
              })
            }
          }).catch((err) => {
            that.requestFailed(err)
          })
        } else {
          that.loginBtn = false
        }
      })
    },
    loginSuccess() {
      if (this.enterpriseInfo.approvalStatus == '1' || this.enterpriseInfo.approvalStatus == '4') {
        this.$router.push({ path: '/ienterprise/enterpriseInfo' }).catch(() => {
          console.log('登录跳转首页出错,这个错误从哪里来的')
        })
      } else {
        this.$router.push({ path: '/dashboard/analysis' }).catch((err) => {
          console.log('登录跳转首页出错,这个错误从哪里来的')
        })
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      }
    },
    uniteLoginClick() {
      let that = this
      getAction('/sys/getUniteLoginUrl', {})
        .then(res => {
          if (res.success) {
            that.uniteLoginUrl = res.result
            window.location.href = that.uniteLoginUrl
          }
        })
        .catch(err => {
          that.$message.error(err.message)
        })
    }
  }
}
</script>

<style lang='less' scoped>
@top-height: 55px;

@bg-height: calc(100vh - @top-height);

.top {
  height: @top-height;
  line-height: @top-height;
  color: #192A44;
}

.bg {
  height: @bg-height;
}

div {
  font-family: "Source Han Sans";
}

.bg {
  background: url("~@/assets/province/login/bj.png") 100% 100%;
}

.login-button {
  background: url("~@/assets/province/login/bg.png") no-repeat;
  background-size: 300px;
}

.qrcode {
  background: url("~@/assets/province/login/qrcode.png") no-repeat;
  background-position: -10px 0;
  border-radius: 0 8px 0 0;
}

.line {
  flex-grow: 1; /* 自动填充剩余空间 */
  height: 1px;
  background: #999;
}

.text {
  padding: 0 10px; /* 文字与线条间距 */
  white-space: nowrap; /* 防止文字换行 */
}

.un-select {
  -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* 标准语法 */
}
</style>

<style scoped>
>>> .ant-form-item {
  margin-bottom: 8px
}
</style>